module.exports = __webpack_public_path__ + "assets/img/bigLogo.f3f83482.png";